import {
  Button,
  ClickAwayListener,
  Stack,
  Tooltip,
  Typography,
} from "@mui/material";
import React, { useEffect, useRef, useState } from "react";
import EmojiPicker from "emoji-picker-react";
import CountHashtags from "../../utils/count-hashtags.js";
import { isMobile, isTablet } from "react-device-detect";
import "../../styles/generate-captions.scss";
import "../../styles/global.scss";
import "../../styles/captionAI.scss";

const CaptionAIEditCaption = (props) => {
  const mobileView = isMobile || isTablet;
  const textInput = useRef(null);
  const [allCaptions, setAllCaptions] = useState(null);
  const [shownCaption, setShownCaption] = useState(null);
  const [pickerOpen, setPickerOpen] = useState(false);
  const [characterLength, setCharacterLength] = useState(0);
  const [hashtagLength, setHashtagLength] = useState(0);

  const switchCaptionPlatform = (caption) => {
    setShownCaption(caption);
  };

  const getPlatformTabColor = (platform) => {
    return platform === shownCaption?.platform.toLowerCase()
      ? platform
      : "inactive-platform";
  };

  const returnToCaptions = () => {
    props.editCaption(null);
  };

  const insertAtCursor = (obj) => {
    return (
      shownCaption.text.slice(0, textInput.current.selectionStart) +
      obj +
      shownCaption.text.slice(textInput.current.selectionStart)
    );
  };

  const updateCaptionsLists = (shown, all) => {
    setShownCaption({
      platform: shownCaption.platform,
      index: shownCaption.index,
      text: shown,
    });
    setAllCaptions(all);
  };

  const handleCaptionChange = (event) => {
    let newCaptions = [...allCaptions];
    newCaptions[shownCaption.index].text = event.target.value;

    updateCaptionsLists(event.target.value, newCaptions);
  };

  const emojiSelected = (emoji) => {
    let tempCaption = insertAtCursor(emoji.emoji);
    let newCaptions = [...allCaptions];
    newCaptions[shownCaption.index].text = tempCaption;

    updateCaptionsLists(tempCaption, newCaptions);
    setPickerOpen(false);
  };

  useEffect(() => {
    const captionsWithIndex = props.captionGroup.captions.map((cap, index) => {
      cap.index = index;
      return cap;
    });

    setAllCaptions(captionsWithIndex);
    setShownCaption(captionsWithIndex[0]);
  }, [props.captionGroup]);

  useEffect(() => {
    if (textInput.current) {
      setCharacterLength(textInput.current.textLength);
      setHashtagLength(CountHashtags(textInput.current.textContent));
    }
  }, [shownCaption]);

  return (
    <Stack direction="column">
      <Stack direction="row" className="platform-tabs-margin">
        {props.captionGroup?.captions.map((cap, index) => {
          return (
            <>
              {cap.platform !== "null" ? (
                <div
                  className={`caption-platform-tab ${getPlatformTabColor(
                    cap.platform.toLowerCase()
                  )}`}
                  onClick={() => switchCaptionPlatform(cap)}
                  data-testid={`platform-tab-${index}`}
                  key={`tab-${index}`}
                >
                  <i
                    className={`fa fa-fw fa-${cap.platform.toLowerCase()}`}
                  ></i>
                </div>
              ) : (
                <></>
              )}
            </>
          );
        })}
      </Stack>
      <textarea
        defaultValue={shownCaption?.text}
        value={shownCaption?.text}
        onChange={handleCaptionChange}
        ref={textInput}
        className="caption-content-holder modal-textbox-theme"
        data-testid="edit-caption-textbox"
      ></textarea>
      <Stack direction="row" justifyContent="space-between">
        {mobileView ? (
          <span>&nbsp;</span>
        ) : (
          <Stack direction="row">
            <Tooltip
              title={<Typography fontSize={14}>Emoji library</Typography>}
              placement="top-start"
            >
              <i
                className="fa fa-fw fa-smile-o caption-icon-spacing clickable font-awesome-icon-style"
                onClick={() => setPickerOpen(!pickerOpen)}
              ></i>
            </Tooltip>
            {pickerOpen ? (
              <ClickAwayListener onClickAway={() => setPickerOpen(false)}>
                <div className="emoji-picker-position">
                  <EmojiPicker onEmojiClick={emojiSelected} />
                </div>
              </ClickAwayListener>
            ) : (
              <></>
            )}
          </Stack>
        )}
        <Stack direction="row">
          <h5 className="content-text captionAI-text-counter">
            {hashtagLength} hashtags
          </h5>
          <h5 className="content-text captionAI-text-counter">
            {characterLength} characters
          </h5>
        </Stack>
      </Stack>
      <Stack direction="row" justifyContent="center">
        <Button variant="contained" color="cc" onClick={returnToCaptions}>
          Done Editing
        </Button>
      </Stack>
    </Stack>
  );
};

export default CaptionAIEditCaption;
